import { createSlice } from "@reduxjs/toolkit";

const initialState = "";

const errorSlice = createSlice({
   name: "error",
   initialState,
   reducers: {
      setError: (action) => {
         return action.payload;
      },
      clearError: () => {
         return initialState;
      },
   },
});

export const { setError, clearError } = initialState;
export const selectErrorMessage = (state) => state.error;

export default errorSlice.reducer;
